import { useEffect } from 'react';

import { useNavigation } from 'hooks/navigation/use-navigation';
import { useRoute } from 'hooks/navigation/use-route';
import { useAuthContext } from 'state/auth';
import { routes } from 'utils/routing';

import { BRAZE_ID_PARAM } from './constants';

const useRedirectAuthIfBrazeId = () => {
  const { isAuthenticated } = useAuthContext();
  const { navigate } = useNavigation();
  const { params } = useRoute<{ [BRAZE_ID_PARAM]: string }>();

  const brazeId = params[BRAZE_ID_PARAM] ?? '';

  useEffect(() => {
    if (brazeId && isAuthenticated) {
      navigate(`${routes.accountInfo}?${BRAZE_ID_PARAM}=${brazeId}`, { replace: true });
    }
  }, [isAuthenticated, brazeId, navigate]);
};

export default useRedirectAuthIfBrazeId;
